import { useEffect, useState } from 'react';
import { FormControl, LinearProgress, MenuItem, TextField, type TextFieldProps } from '@mui/material';
import { fileUrl, getFileList } from '../api/files';

interface FileSelectorProps extends Omit<TextFieldProps, 'onChange'> {
    value: string;
    onChange: (name: string) => void;
}

export function FileSelector({ value, onChange, ...props }: FileSelectorProps) {
    const [list, setList] = useState<string[]>([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let active = true;
        getFileList()
            .then((files) => {
                if (active) setList(files);
            })
            .catch(() => {
                if (active) setList([]);
            })
            .finally(() => {
                if (active) setLoading(false);
            });
        return () => {
            active = false;
        };
    }, []);

    // Un valore salvato che non è tra i file elencati (es. URL esterno o un percorso
    // `/assets/…`): MUI segnala un "out-of-range value" se non esiste un `MenuItem`
    // corrispondente. Aggiungerne uno evita il warning e non mostra un valore fuori
    // range quando si apre il selettore.
    const needsValueItem = value !== '' && !list.includes(value);

    return (
        <FormControl fullWidth variant="filled">
            <TextField select fullWidth value={value} onChange={(e) => onChange(e.target.value)} {...props}>
                {needsValueItem && (
                    <MenuItem value={value}>
                        <span className="flex items-center gap-2">{value}</span>
                    </MenuItem>
                )}
                {loading ? (
                    <MenuItem disabled>
                        <LinearProgress className="w-full" />
                    </MenuItem>
                ) : list.length === 0 ? (
                    <MenuItem disabled>Non ci sono immagini</MenuItem>
                ) : (
                    list.map((name) => (
                        <MenuItem key={name} value={name}>
                            <span className="flex items-center gap-2">
                                <img src={fileUrl(name)} alt="" className="h-12 w-12 rounded object-cover" />
                                {name}
                            </span>
                        </MenuItem>
                    ))
                )}
            </TextField>
        </FormControl>
    );
}
